import { LandersForeclosureModel } from "./../models/landers_foreclosure";

(function (LANDERS_FORECLOSURE) {

  var init = function () {
    LANDERS_FORECLOSURE.model = new LandersForeclosureModel(defaultCriteriaOptions(), extraParameters());
  };

  var defaultCriteriaOptions = function () {
    return {
      location: MOVE.SearchHelper.getRecentSearchedLocation(MOVE.CONSTANTS.DEFAULT_LANDING_PAGE_LOCATION),
      property_status: MOVE.CONSTANTS.PROPERTY_STATUS.forSale
    };
  };

  var extraParameters = function () {
    return {medianPrice: getMedianPrice()};
  };

  var getMedianPrice = function () {
    var $object = $("#foreclosure_landing");
    if ($object.data().medianprice !== undefined && $object.data().dspmedianprice !== undefined) {
      return {
        median_price: $object.data().medianprice,
        dsp_median_price: $object.data().dspmedianprice
      };
    } else {
      return {};
    }
  };

  LANDERS_FORECLOSURE.LandingPage = {
    init: init
  };
})(MOVE.LANDERS_FORECLOSURE);
MOVE.LANDERS_FORECLOSURE.LandingPage.init();



// WEBPACK FOOTER //
// ./landers_foreclosure/controllers/landers_foreclosure.js